import React from 'react';
import {
    getDefaultTableOptions,
    JSONParseFix,
    getDefaultTableOptionsJSON,
    saveTableColumns,
    getLookup
} from '../../../common/util/util-helpers';
import Resources from "../../../data/services/resources";
import {Field, FieldsManager} from "../../../data/services/fields";
import {fieldsToHtml, fillFieldsFromData} from "../../../common/util/util-fields";
import {
    DEFAULT_CRUD_STATE,
    DEFAULT_QUERY_LIMIT,
    DELETE_PERM, EXPIRY_COMPANIES_ITEM_TYPES,
    EXPIRY_FLEET_ITEM_TYPES,
    REFERENCE_TYPE_TRUCK,
    REFERENCE_TYPES_SYSTEM_LINKS,
    UPDATE_PERM
} from "../../../common/util/util-consts";
import {useEffect, useState} from "react";
import LocalStorage from "../../../common/util/localStorage";
import {checkPerm, getProp, openInNewTab} from "../../../common/util/util-helpers";
import {createResource, deleteResource, getResource} from "../../../data/actions/resource";
import moment from "moment";
import Badge from "../../../common/components/badge";
import {toFrontDate} from "../../../common/util/util-dates";
import ActiveFilters from "../../../common/components/resource-table/table-components/active-filters";
import TableCard from "../../../common/components/resource-table/table-components/table-card";
import TableFilters from "../../../common/components/resource-table/table-components/table-filters";
import PopoverDatePicker from "../../../common/components/popover/popover-datepicker";
import NoRecordsTable from "../../../common/components/no-records-found/no-records-table";
import TableCardFooter from "../../../common/components/resource-table/table-components/table-card-footer";
import Pagination from "../../../common/components/resource-table/table-components/pagination";
import ModalConfirm from "../../../common/components/modal/modal-confirm";
import ResourceTable from "../../../common/components/resource-table";
import {EyeIcon, TrashIcon} from "@heroicons/react/24/outline";
import TableSettingsPopOver from "../../../common/components/resource-table/table-components/table-settings-popover";
import TableOptionsDialog from "../../../common/components/resource-table/table-components/table-options-dialog";
import ModalSaveResource from "../../../common/components/modal/modal-save-resource";
import Button from "../../../common/components/button";
import {CREATE_PERM, MATRIX_PRICING_ZIP, MATRIX_PRICING_ZONE} from "../../../util/util-constants";
import ResourceTableDialog from "../../../common/components/modal/resource-table-dialog";
import {useSelector} from "react-redux";
import ModalDefault from "../../../common/components/modal/modal-default";


const ExpiryItemsTab = ({translate, dispatch, resourceName, match, resource, breakpoint, ExpiryType}) => {

    /** Constants
     ================================================================= */
    const pagePath = match.path.substring(1)
    const dialogResource = useSelector(state => state.dialogResource);

    const [isAllContactsModalOpen, setIsAllContactsModalOpen] = useState(false)
    const [selectedContactsToAdd, setSelectedContactsToAdd] = useState({})
    const [contactsList, setContactsList] = useState({})
    const [selectedContacts, setSelectedContacts] = useState({})
    const [viewModalOpen, setViewModalOpen] = useState(false)

    const [fields, setFields] = useState(() => getFields());


    const [tableOptions, setTableOptions] =  useState(getDefaultTableOptions(getFields(), {
        behaviour: {
            rowSelect: true,
            canAdjustWidth: true,
            hasMenu: true
        },
        style: {
            condensed: true,
            isGPUAccelerated: true
        }
    }, pagePath, translate))

    const [editModalOpen, setEditModalOpen] = useState(false)


    /** Fields/Data definitions
     ================================================================= */
    function getFields(item) {
        const emailArray = item?.Emails
            ? selectedItem && item.Emails.split(",").map(email => ({
            label: email.trim(),
            value: email.trim()
        })) : [];

        let EntityTypeID = null;
        switch (ExpiryType) {
            case Resources.DispatchExpiry:
                break;
            case Resources.FleetExpiry:
                EntityTypeID =  {
                    [5]: 'Truck documents',
                    [6]: 'Trailer documents',
                };
                break;
            case Resources.PersonnelExpiry:
                EntityTypeID =  {
                    [1]: 'Driver documents',
                    [2]: 'Agent documents',
                    [3]: 'Employee documents'
                };
                break;
            case Resources.CompaniesExpiry:
                EntityTypeID =  {
                    [7]: 'Carrier documents',
                    [8]: 'Vendor documents',
                    [9]: 'Customer documents'
                };
                break;
            default:
                break;
        }

        let fields = {};
        switch (resourceName) {
            case Resources.DispatchExpiry:
            case Resources.FleetExpiry:
            case Resources.PersonnelExpiry:
            case Resources.CompaniesExpiry:
                fields = {
                    Reference: new Field('Reference', '', [], false, 'text', {
                        label: "REFERENCE_TYPE",
                        render: (item) => (item.ReferenceType ? translate('reference_type.' + item.ReferenceType) : "") + ' ' + item.Reference,
                        omitSort: true
                    }),
                    Description: new Field('Description', '', [], false, 'text', {
                        omitSort: true
                    }),
                    Date: new Field('Date', '', [], false, 'text', {
                        label: "ExpiryDate",
                        render: (item) => renderDueDate(item),
                        omitSort: true
                    }),
                }
                break;
            case Resources.ExpiryWarnings:
                const fieldTemplates = {
                    EntityTypeID: new Field("EntityTypeID", '', ['empty'], !!item, 'select', {
                        addContainerClass: 'col-span-12'
                    }, {values: EntityTypeID, valueSort: true}),
                    Emails: new Field("Emails", '', [], true, 'creatable-csv', {addContainerClass: 'col-span-12'}, {isMulti: true, isDisabled: true}),
                    Notes: new Field('Notes', '', [], !!item, 'textarea', {addContainerClass: 'col-span-12'}),
                    IsDocument: new Field("IsDocument", 1, [''], false, 'integer', {
                        hideTable: true,
                        hideDialog: true
                    }),
                }

                return fillFieldsFromData(fieldTemplates, item)
            default:
                break;
        }

        return fillFieldsFromData(fields, item);
    }

    const resourceIsFleetExpiry = () => {
        return resourceName == Resources.FleetExpiry || resourceName == Resources.CompaniesExpiry;
    }

    const getQueryFilterFields = (item = {}) => {
        const fieldTemplates = {
            query: new Field('query', '', [''], false, 'search', {}, {}),
            ...(!ExpiryType && {
            StartDate: new Field('StartDate', '', [], false, 'date', {labelType: "stack"}),
            EndDate: new Field('EndDate', '', [], false, 'date', {labelType: "stack"}),
            Type: new Field('Type', '', [''], false, resourceIsFleetExpiry() ? 'select' : 'hidden', {
                label: 'ExpiryItemType',
                labelType: 'stack'
            }, {
                values: resourceName == Resources.CompaniesExpiry ? EXPIRY_COMPANIES_ITEM_TYPES : EXPIRY_FLEET_ITEM_TYPES,
                isClearable: true
            }),
            DocumentTypeID: new Field('DocumentTypeID', '', [''], false, resourceName == Resources.CompaniesExpiry ? 'select' : 'hidden', {
                label: 'ExpiryItemType',
                labelType: 'stack'
            }, {
                values: getLookup('DocumentType'),
                isClearable: true
            }),
            Overdue: new Field('Overdue', '', [''], false, 'checkbox', {}, {})}),
            limit: new Field('limit', DEFAULT_QUERY_LIMIT, [''], false, 'select', {hideLabel: true}, {menuPlacement: "top"})
        }

        return fillFieldsFromData(fieldTemplates, item);
    }

    function handleSetTableOptions(options) {
        setTableOptions(options);
        if (pagePath) {
            saveTableColumns(pagePath, options);
        }
    }

    /** State
     ================================================================= */
    const [query, setQuery] = useState(DEFAULT_CRUD_STATE)
    const [queryFilterFields, setQueryFilterFields] = useState(LocalStorage.has(pagePath + '_state') ? getQueryFilterFields(FieldsManager.getFieldKeyValues(JSONParseFix(LocalStorage.get(pagePath + '_state'))?.queryFilterFields)) : getQueryFilterFields())
    const [selectedItem, setSelectedItem] = useState(null)
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false)
    const [isConfirmDeleteModalOpen, setIsConfirmDeleteModalOpen] = useState(false)
    const [isColumnsDialogVisible, setIsColumnsDialogVisible] = useState(false)


    /** Helpers
     ================================================================= */
    const getResourceName = () => {
        return resourceName;
    }

    const getQuery = () => {
        let EntityTypeID = null;
        switch (ExpiryType) {
            case Resources.DispatchExpiry:
                break;
            case Resources.FleetExpiry:
                EntityTypeID = "5,6";
                break;
            case Resources.PersonnelExpiry:
                EntityTypeID = "1,2,3";
                break;
            case Resources.CompaniesExpiry:
                EntityTypeID = "7,8,9";
                break;
            default:
                break;
        }

        return {
            offset: query.offset,
            sort: query.sort,
            sortBy: query.sortBy,
            ...FieldsManager.getFieldKeyValues(queryFilterFields),
            searchFields: JSON.stringify(EntityTypeID && {EntityTypeID: EntityTypeID})
        }
    }

    const saveFilters = () => {
        LocalStorage.persistState(pagePath, {
            query,
            queryFilterFields
        }, Object.keys(getQuery()))
    }

    const getResourceTab = (it) => {
        if (it.ReferenceType === REFERENCE_TYPE_TRUCK) {
            switch (it.Tab) {
                case "documents":
                    return Resources.TruckDocuments
                case "permits":
                    return Resources.TrucksPermits
                case "expiry":
                    return Resources.TrucksExpiry
                case "info":
                    return Resources.TrucksInfo
            }
        } else {
            switch (it.Tab) {
                case "documents":
                    return Resources.TrailerDocuments
                case "expiry":
                    return Resources.TrailersExpiry
                case "info":
                    return Resources.Trailer
            }
        }
    }

    const checkPermForItem = (it) => {
        let resource;

        switch (it.ReferenceType) {
            case "tbl_Truck": {
                resource = getResourceTab(it)
                break;
            }
            case "tbl_Trailer": {
                resource = getResourceTab(it)
                break;
            }
            case "tbl_Load": {
                resource = Resources.LoadInfo
                break;
            }
            case "tbl_Customer": {
                resource = Resources.CustomersInfo
                break;
            }
            case "tbl_Carrier": {
                resource = Resources.Carrier
                break;
            }
            case "tbl_Vendor": {
                resource = Resources.VendorsInfo
                break;
            }
            case "tbl_Driver": {
                resource = Resources.DriverInfo
                break;
            }

            default: {
                return Resources.ExpiryWarnings
            }
        }

        return checkPerm(resource, UPDATE_PERM)
    }
    /** Data events
     ================================================================= */
    const fetchData = () => {
        dispatch(getResource({
            user: LocalStorage.get('user'),
            query: getQuery(),
            resource: getResourceName()
        }))
    }

    /** UI events
     ================================================================= */
    const handleFilterInputChange = (name, value) => {
        setQueryFilterFields(FieldsManager.updateField(queryFilterFields, name, value))
    }

    const handleUpdateQueryFields = (fields) => {
        setQueryFilterFields(fields);
    }

    const handleToggleViewModal = (item = null) => {
        const path = REFERENCE_TYPES_SYSTEM_LINKS[item.ReferenceType]

        switch (item.ReferenceType) {
            case "tbl_Truck":
            case "tbl_Trailer": {
                const targetTabURLParam = item.ReferenceType == REFERENCE_TYPE_TRUCK ? `?tab=trucks/${item.Tab}` : `?tab=trailers/${item.Tab}`
                openInNewTab(path + item.ReferenceID + targetTabURLParam)
                break;
            }
            default: {
                openInNewTab(path + item.ReferenceID)
            }
        }
    }

    const handleClearFiltersClick = () => {
        setQueryFilterFields(getQueryFilterFields())
    }

    const handleUpdateOffset = (offset, num) => {
        setQuery((prevState) => ({
            ...prevState,
            offset: offset,
            paginationPage: num
        }))
    }

    const handleUpdateSort = (sortBy) => {
        setQuery((prevState) => ({
            ...prevState,
            sortBy: sortBy,
            sort: (query.sortBy === sortBy) ? (query.sort === 'ASC' ? 'DESC' : 'ASC') : 'ASC'
        }))
    }

    const handleToggleConfirmModal = (item = null) => {
        setIsConfirmModalOpen(!isConfirmModalOpen)
        setSelectedItem(item)
    }

    const setTableColumnOptions = (columns) => {
        let tableOptionsUpdate = Object.assign({}, tableOptions)

        tableOptionsUpdate.columns = columns.reduce((memo, it) => {
            memo[it.name] = it
            return memo
        }, {})

        setTableOptions(tableOptionsUpdate)
        setIsColumnsDialogVisible(false)
        saveTableColumns(pagePath, tableOptionsUpdate)
    }

    const getDefaultTableColumnOptions = () => {
        return getDefaultTableOptionsJSON(fields, {}, translate)
    }

    const handleToggleCreateModal = (item = null) => {
        setEditModalOpen(!editModalOpen)
        setSelectedItem(item)
        setContactsList({});
        setFields(getFields());
    }

    const handleToggleConfirmDeleteModal = (item = null) => {
        setIsConfirmDeleteModalOpen(!isConfirmDeleteModalOpen)
        setSelectedItem(item)
    }

    const handleToggleAllContactsModal = () => {
        setIsAllContactsModalOpen(!isAllContactsModalOpen);
        setSelectedContactsToAdd(contactsList);
    }

    const handleAddContacts = () => {
        setContactsList(selectedContactsToAdd);
        if (selectedContactsToAdd) {
            fields.Emails.value = Object.values(selectedContactsToAdd).map(item => ({
                label: item.Email,
                value: item.Email
            }))
        }
        handleToggleAllContactsModal()
    }

    const handleSelectContact = (row, id) => {

        const isAddContacts = isAllContactsModalOpen
        const selectedContactsToAddNew = Object.assign({}, selectedContactsToAdd);
        const selectedContactsNew = Object.assign({}, selectedContacts);

        if (isAddContacts) {
            if (selectedContactsToAddNew[id]) {
                delete selectedContactsToAddNew[id]
            } else {
                selectedContactsToAddNew[id] = row
            }
        } else {
            if (selectedContactsNew[id]) {
                delete selectedContactsNew[id]
            } else {
                selectedContactsNew[id] = row
            }
        }

        setSelectedContactsToAdd(selectedContactsToAddNew);
        setSelectedContacts(selectedContactsNew);
    }

    const handleSelectAllContacts = (areAllSelected) => {

        const isAddContacts = isAllContactsModalOpen
        const prop = getProp(dialogResource, 'data.list', [])

        const selectedContactsToAddNew = Object.assign({}, selectedContactsToAdd);
        const selectedContactsNew = Object.assign({}, selectedContacts);

        prop.map(item => {
            if (!areAllSelected) {
                isAddContacts ?
                    selectedContactsToAddNew[item.ContactID] = item
                    :
                    selectedContactsNew[item.ContactID] = item;
            } else {
                isAddContacts ?
                    delete selectedContactsToAddNew[item.ContactID]
                    :
                    delete selectedContactsNew[item.ContactID]
            }
        });

        setSelectedContactsToAdd(selectedContactsToAddNew);
        setSelectedContacts(selectedContactsNew);
        setMissingContact(false);
    }

    const handleToggleViewExpiryModal = (item = null) => {
        setViewModalOpen(!viewModalOpen)
        setSelectedItem(item)
    }

    /** Lifecycle
     ================================================================= */
    useEffect(() => {
        fetchData()
        saveFilters()
    }, [query, queryFilterFields]);

    useEffect(() => {
        if (breakpoint && breakpoint.index <= 1 && getProp(queryFilterFields, "limit.value", 10) !== 10) {
            handleFilterInputChange('limit', 10);
        }
    }, [breakpoint])

    /** Render
     ================================================================= */
    const renderDueDate = (item) => {
        if (!item.Date) {
            return undefined;
        }

        let ExpiryDate = item.Date
        let today = moment().format("YYYY-MM-DD HH:mm:ss")
        let x = 7
        let xDaysBefore = moment(ExpiryDate).add(-x, 'days').format("YYYY-MM-DD HH:mm:ss")
        let styles = ''
        if (ExpiryDate) {
            if (xDaysBefore < today && today < ExpiryDate) {
                styles = 'warning'
            }
            if (today > ExpiryDate) {
                styles = 'danger'
            }
        }
        return (
            <>
                <Badge type={styles}>
                    {toFrontDate(ExpiryDate)}
                </Badge>
            </>
        )
    }

    const data = getProp(resource, 'data.list', [])
    const count = getProp(resource, 'data.count', 0)
    const isLoading = getProp(resource, 'isLoading', false)

    return (
        <>
            <div className="flex items-center justify-between">
                <ActiveFilters
                    filterFields={queryFilterFields}
                    onLabelClick={handleFilterInputChange}
                    onClearFiltersClick={handleClearFiltersClick}
                    translate={translate}
                />

                <div className={"flex ml-auto"}>
                    <TableSettingsPopOver
                        options={tableOptions}
                        setOptions={setTableOptions}
                        toggleColumnSettingsDialog={() => setIsColumnsDialogVisible(true)}
                        translate={translate}
                    />

                    {resourceName === Resources.ExpiryWarnings && (
                        <Button
                            hasPerm={checkPerm(Resources.ExpiryWarnings, CREATE_PERM)}
                            className={`btn btn-primary`}
                            onClick={() => {
                                handleToggleCreateModal()}}
                        >
                            {translate('btn.create_new')}
                        </Button>
                    )}
                </div>
            </div>

            <TableCard>
                <TableFilters
                    popoverClass="relative"
                    hideLimit
                    filterFields={queryFilterFields}
                    handleInputChange={handleFilterInputChange}
                    customHeaderHtml={!ExpiryType ?
                        (<PopoverDatePicker
                        queryFields={queryFilterFields}
                        onQueryInputChange={handleFilterInputChange}
                        updateFields={handleUpdateQueryFields}
                        translate={translate}/>)
                        :
                        (<div></div>)
                    }
                    translate={translate}
                    onRefreshTable={fetchData}
                    isLoading={isLoading}
                />

                <ResourceTable
                    data={data}
                    options={tableOptions}
                    tableKey="ReferenceID"

                    verticalTableIsVisible={breakpoint.index <= 1}
                    fields={fields}
                    translate={translate}
                    isLoading={isLoading}

                    limit={queryFilterFields?.limit?.value ?? query.limit}
                    offset={query.offset}
                    page={query.paginationPage}
                    onOffsetChange={handleUpdateOffset}

                    sort={query.sort}
                    sortBy={query.sortBy}
                    onSortChange={handleUpdateSort}

                    onRowClick={(it) => (resourceName !== Resources.ExpiryWarnings && checkPermForItem(it)) ? handleToggleViewModal(it) : handleToggleViewExpiryModal(it)}

                    actions={[
                        {
                            action: (it) => handleToggleViewModal(it),
                            icon: () => EyeIcon,
                            visible: () => resourceName !== Resources.ExpiryWarnings,
                            hasPerm: (it) => checkPermForItem(it),
                            title: translate('btn.open_in_new_tab')
                        },
                        {
                            action: (it) => handleToggleViewExpiryModal(it),
                            icon: () => EyeIcon,
                            visible: () => resourceName === Resources.ExpiryWarnings,
                            hasPerm: (it) => checkPermForItem(it),
                            title: translate('btn.view')
                        },
                        {
                            action: (it) => handleToggleConfirmModal(it),
                            icon: () => TrashIcon,
                            visible: (it) => ((it.LoadStopByID || it.LoadStopID) && resourceName === Resources.DispatchExpiry),
                            hasPerm: () => checkPerm(Resources.DispatchExpiry, DELETE_PERM),
                            title: translate('btn.mark_item_as_retrieved')
                        },
                        {
                            action: (it) => handleToggleConfirmDeleteModal(it),
                            icon: () => TrashIcon,
                            visible: () => resourceName === Resources.ExpiryWarnings,
                            hasPerm: () => checkPerm(Resources.ExpiryWarnings, DELETE_PERM),
                            title: translate('btn.delete')
                        }
                    ]}
                    saveTableOptions={handleSetTableOptions}
                />

                <NoRecordsTable
                    show={(data.length === 0) && !isLoading}
                    canCreate={false}
                    title={translate('text.no_matching_records')}
                    className={"pt-16 pb-14 px-6"}
                />

                {!!data.length && !isLoading && (
                    <TableCardFooter>
                        <Pagination
                            count={count}
                            isLoading={isLoading}
                            hideRowsPerPage={breakpoint.index <= 1}
                            handleQueryChange={
                                (name, value, currentPage) => name === "offset"
                                    ? handleUpdateOffset(value, currentPage)
                                    : handleFilterInputChange(name, value)
                            }
                            pageOffset={query.offset}
                            queryFields={queryFilterFields}
                            translate={translate}
                        />
                    </TableCardFooter>
                )}

            </TableCard>
            <TableOptionsDialog
                show={isColumnsDialogVisible}
                pagePath={pagePath}
                columns={tableOptions.columns}
                setTableColumnOptions={setTableColumnOptions}
                getDefaultTableColumnOptions={getDefaultTableColumnOptions}
                onClose={() => setIsColumnsDialogVisible(false)}
                translate={translate}
            />

            <ModalConfirm
                title={translate("text.confirm")}
                show={!!isConfirmModalOpen}
                text={translate('message.are_you_sure_mark_as_retrieved')}
                onClose={handleToggleConfirmModal}
                buttonLabel={translate('btn.confirm')}
                closeButtonLabel={translate('text.cancel')}
                translate={translate}
                onConfirm={() => {
                    dispatch(deleteResource({
                        user: LocalStorage.get('user'),
                        query: {
                            LoadStopByID: selectedItem.LoadStopByID ?? null,
                            LoadStopID: selectedItem.LoadStopID ?? null
                        },
                        piggyQuery: getQuery(),
                        errorMessage: true,
                        successMessage: translate('message.item_marked_as_retrieved'),
                        resource: Resources.DispatchExpiry,
                        piggyResource: Resources.DispatchExpiry,
                    }))
                    handleToggleConfirmModal()
                }}
            />

            <ModalSaveResource
                title={translate("text.createWarning")}
                gridColsClass={"grid-cols-12"}
                show={editModalOpen}
                translate={translate}
                fields={fields}
                onClose={handleToggleCreateModal}
                onSubmit={(params) => {
                    if (params && !!Object.values(contactsList).length) {
                        params.AlertContactIDs = Object.keys(contactsList).join(',');
                        dispatch(createResource({
                            user: LocalStorage.get("user"),
                            query: getQuery(),
                            params: params,
                            errorMessage: true, successMessage: translate("text.warning_created"),
                            resource: Resources.ExpiryWarnings,
                            piggyResource: Resources.ExpiryWarnings,
                        }));
                    }

                    if (!!Object.values(contactsList).length){
                        handleToggleCreateModal();
                    }

                }}
                htmlBefore={
                    <div className={"mx-5 mt-10"}>
                        <Button onClick={() => handleToggleAllContactsModal()}
                                className={"flex mx-auto my-2 btn-outline"}>
                            Contacts list (choose one or more system users to receive email and notification)
                        </Button>

                        <div className={"flex justify-center"}>
                            Contacts selected:
                            <span className={"ml-2"}>{Object.values(contactsList).length}</span>
                        </div>
                    </div>
                }

                htmlAfter={
                    !Object.values(contactsList).length && (
                        <div className={"m-5"}>
                            <div className={"flex justify-center text-red-500"}>
                                Contacts must be selected before proceeding.
                            </div>
                        </div>
                    )
                }
                metadata={{}}
            />

            <ModalConfirm
                title={translate("text.confirm")}
                show={!!isConfirmDeleteModalOpen}
                text={translate('message.confirm_delete_generic', [selectedItem?.Notes])}
                onClose={handleToggleConfirmDeleteModal}
                buttonLabel={translate('btn.confirm')}
                closeButtonLabel={translate('text.cancel')}
                translate={translate}
                onConfirm={() => {
                    dispatch(deleteResource({
                        user: LocalStorage.get('user'),
                        query: {
                            ExpiryWarningID: selectedItem.ExpiryWarningID
                        },
                        piggyQuery: getQuery(),
                        errorMessage: true,
                        successMessage: translate('message.warning_deleted'),
                        resource: Resources.ExpiryWarnings,
                        piggyResource: Resources.ExpiryWarnings,
                    }))
                    handleToggleConfirmDeleteModal();
                }}
            />

            <ResourceTableDialog
                show={isAllContactsModalOpen}
                dialogResource={dialogResource}
                resource={Resources.ContactsQuick}
                title={translate("btn.add_contacts")}
                dispatch={dispatch}

                fields={{
                    FirstName: new Field('FirstName', '', [''], false),
                    LastName: new Field('LastName', '', [''], false),
                    Email: new Field('Email', '', [''], false)
                }}

                fieldsFilter={{
                    query: new Field('query', '', [''], false, 'search', {addContainerClass: 'col-span-3'}),
                    ContactGroupID: new Field('ContactGroupID', '', [''], false, 'select-search', {addContainerClass: 'col-span-3'}, {
                        isClearable: true,
                        api: 'api/' + Resources.ContactGroupsQuick,
                        query: {},
                        searchMap: (it) => ({
                            label: it.ContactGroupName,
                            value: it.ContactGroupID,
                            metadata: it
                        })
                    }),
                }}

                defaultQuery={{IsSystemUser: 1}}
                defaultAction={handleSelectContact}

                tableKey={"ContactID"}
                onSelectRow={handleSelectContact}
                onSelectAllClick={handleSelectAllContacts}
                selectedRows={selectedContactsToAdd}

                buttonLabel={translate('btn.confirm_selection')}
                onButtonClick={handleAddContacts}
                buttonDisabled={false}

                onClose={() => {setIsAllContactsModalOpen(false)}}
                translate={translate}
            />

            <ModalDefault
                show={viewModalOpen}
                widthClass="max-w-xl"
                title={translate('modal_heading.expiryView')}
                hideDialogFooter={true}
                onClose={handleToggleViewExpiryModal}
                closeButtonLabel={translate('btn.close')}
                translate={translate}
            >
                <div className={"m-5"}>
                    {fieldsToHtml(Object.values(Object.assign({}, getFields(selectedItem))), translate, (name, value) => {}, {})}
                </div>
            </ModalDefault>
        </>
    )
}

export default ExpiryItemsTab;
